import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.catalog.actions';
import * as home from '../../../../actions/process.home.actions';

import Hidden from '@material-ui/core/Hidden';

import Loading from '../../../dialogs/loading';
import Menu from '../Menu';
import Catalog from './Catalog';
import Error from '../../../dialogs/Error';

class Catalogs extends React.Component {
    state = {
        hide: false,
        open: undefined,
    };

    constructor(props) {
        super(props);
        if (props.id) 
            props.getCatalog(props.id);
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info, catalog, catalog_is_loading } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '62') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {catalog === undefined && catalog_is_loading && <Loading open opacity />}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={3} />
                        </div>
                    </Hidden>
                    <div className={'flex_full'}>
                        <div
                            className={'flex_full overflow_y_scroll height100 bg_ice_blue showbar'}
                            onScroll={this.handleScroll}
                        >
                            <Catalog id={this.props.id} />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Catalogs.propTypes = {
    catalog_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        catalog_is_loading: state.catalog_is_loading,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Catalogs);



// WEBPACK FOOTER //
// ./src/components/complex/manage/catalog/Index.js